import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form'
import { Form, Button } from 'react-bootstrap';
import { BsPencil } from "react-icons/bs";
import Flex from 'components/common/Flex';
import { useState }  from 'react';
import { Modal  } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux'
import { updateAnalisiStrategica } from 'features-csvc/reduxStore/questCorrenteSlice';
import { TextWithLineBreaks } from '../components-csvc/TextWithLineBreaks'

import FalconCloseButton from 'components/common/FalconCloseButton';

const AnalisiStrategica = () => {
// ----------------------------------------------------------
//  INIZIO GESTIONE Modal
const [modalShow, setModalShow] = useState(false);

const handleOpenModal = () => {
  setModalShow(true)
}

const handleCloseModal = () => {
  setModalShow(false)
}
//  FINE GESTIONE Modal
// ----------------------------------------------------------

// ----------------------------------------------------------
  // estraggo analisi strategica da questionarioCorrente:
  const questionarioCorrente = useSelector((state) => state.questCorrente);
  const analisiStrategica = questionarioCorrente.analisiStrategica

  console.log(analisiStrategica)
// ----------------------------------------------------------



//  INIZIO GESTIONE PER react-hook-form
const dispatch = useDispatch();
const { control, handleSubmit } = useForm({
  defaultValues: {
    analisiStrategica:analisiStrategica         //  2025-07-17 ex: analisiStrategica:''
  }
});

const onSubmit = (data) => {
  console.log(data);
  const updatedValues = {
      questionarioUuid: questionarioCorrente.questionarioUuid, 
      analisiStrategica: data.analisiStrategica
  }
  console.log('analisiStrategica - updatedValues: ', updatedValues)
  
  dispatch(updateAnalisiStrategica(updatedValues))
  setModalShow(false)
};
//  FINE GESTIONE PER react-hook-form




  return (<>
    <Card className="text-left">
      <Card.Body className="p-5">
        <h1 className="text-center">
          <strong>Analisi strategica dell'azienda per la sostenibilità</strong>
        </h1>
        <br></br>

        <Card className="text-left">
          <Card.Body className="p-5">
            <Card.Title>
              <Row className="g-0 justify-content-between" style={{margin:"1%"}} >
                <Col sm="9">
                  <Flex alignItems="center">
                    <div>
                      <h5 className="text-info fw-medium mb-0"  style={{marginBottom:"3%"}}>Analisi strategica della Direzione <br />e/o riferimenti a documenti aziendali relativi.</h5>
                    </div>
                  </Flex>
                </Col>
                <Col md="auto" className="mb-3 mb-md-0">
                  <Row className="g-3 gy-md-0 h-100 align-items-center">
                    <Col xs="auto" style={{margin:"10%"}} >
                    <Button variant='danger'  onClick={handleOpenModal}>
                      <BsPencil />
                    </Button>                
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card.Title>
            <Card.Text>
             {<TextWithLineBreaks text={questionarioCorrente.analisiStrategica} />}
            </Card.Text>
          </Card.Body>
        </Card><br></br>
      </Card.Body>
    </Card>

    <Modal size="lg" show={modalShow} onHide={handleCloseModal} backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>
            Analisi strategica della Direzione <br />e/o riferimenti a documenti aziendali relativi
          </Modal.Title>
          <FalconCloseButton onClick={handleCloseModal}/>
        </Modal.Header>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body>
            <Form.Group controlId="formAnalisiStrategica" style={{marginTop:"2%"}}>
              <Form.Label>Analisi Strategica</Form.Label>
              <Controller
                  name="analisiStrategica"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                      <Form.Control 
                          as="textarea" 
                          rows={15} 
                          cols={50} 
                          {...field} 
                      />
                  )}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>Annulla</Button>
            <Button variant="primary" type="submit">Invia</Button>
          </Modal.Footer>
        </form>
      </Modal>

  </>);
};

export default AnalisiStrategica;

/*
              <span className="fw-small">
                {questionarioCorrente.analisiStrategica.map((singleRow) => (<><p className="text-primary  mb-0">{singleRow.text}</p></>))}
              </span>


              {<TextWithLineBreaks text={thisKpiValues.perPrecGiust} />}

              {questionarioCorrente.analisiStrategica} 

              {<TextWithLineBreaks text={questionarioCorrente.analisiStrategica} />}
*/